module.exports = "<div class=\"ibox default border-bottom\" dropdown>\n  <div class=\"ibox-title bg-muted no-borders clickable\" (click)=\"collapse($event)\">\n    <h5>\n      <div *ngIf=\"color\" class=\"square bg-{{color}} pull-left m-r-sm\"></div> {{title}}</h5>\n    <div class=\"ibox-tools\">\n      <a class=\"collapse-link\" (click)=\"collapse($event)\">\n        <i class=\"fa fa-chevron-up\"></i>\n      </a>\n    </div>\n  </div>\n  <div class=\"ibox-content\">\n    <ng-content></ng-content>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/iboxtools/iboxtools.component.html
// module id = ./src/app/modules/iboxtools/iboxtools.component.html
// module chunks = main